<script setup lang="ts">
import NitTag from './NitTag.vue'
interface Props {
  type: 'pro' | 'team'
}
defineProps<Props>()
</script>

<template>
  <div>
    <NitTag v-if="type === 'pro'" :color="'main'"> プロ </NitTag>
    <NitTag v-if="type === 'team'" :color="'accent'"> チーム </NitTag>
  </div>
</template>
